/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { service } from '@ember/service';
import { convertToLocalTime } from 'my-phorest/utils/local-datetime-helpers';
import { format as formatDate } from 'my-phorest/utils/local-date-helpers';
import { format as formatTime } from 'my-phorest/utils/local-time-helpers';

export default class ChatsListChatComponent extends Component {
  @service intl;

  get lastMessageDate() {
    const date = new Date(this.args.date);
    const today = new Date();

    if (
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear()
    ) {
      return formatTime(convertToLocalTime(this.args.date), this.intl);
    }

    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    if (
      date.getDate() === yesterday.getDate() &&
      date.getMonth() === yesterday.getMonth() &&
      date.getFullYear() === yesterday.getFullYear()
    ) {
      return this.intl.t('global.yesterday');
    }

    return formatDate(this.args.date, this.intl, 'tiny');
  }
}
